import {
  GET_PURCHASEORDER_REQUEST,
  GET_PURCHASEORDER_SUCCESS,
  GET_PURCHASEORDER_PAGINATION,
  GET_PURCHASEORDER_FAIL,
  CREATE_PURCHASEORDER_REQUEST,
  CREATE_PURCHASEORDER_SUCCESS,
  CREATE_PURCHASEORDER_FAIL,
  UPDATE_PURCHASEORDER_REQUEST,
  UPDATE_PURCHASEORDER_SUCCESS,
  UPDATE_PURCHASEORDER_FAIL,
  DELETE_PURCHASEORDER_REQUEST,
  DELETE_PURCHASEORDER_SUCCESS,
  DELETE_PURCHASEORDER_FAIL,
  GET_VENDORPURCHASEORDER_REQUEST,
  GET_VENDORPURCHASEORDER_SUCCESS,
  GET_VENDORPURCHASEORDER_FAIL,
  GENERATE_PDF_REQUEST,
  GENERATE_PDF_SUCCESS,
  GENERATE_PDF_FAIL,
  GET_SELECTEDPO_REQUEST,
  GET_SELECTEDPO_SUCCESS,
  GET_SELECTEDPO_FAIL,
  ADD_SELECTED_INVOICE,
  REMOVE_SELECTED_INVOICE,
  CLEAR_SELECTED_PO,
  REMOVE_SELECTED_PO,
} from "../types/purchaseOrderTypes";
import Axios from "axios";
import { LOCAL_STORAGE } from '../../config/const'
import APP_CONSTANT from "../../config/constants";
import cogoToast from "cogo-toast";

export const deletePurchaseOrder = (id) => async (dispatch) => {
  dispatch({ type: DELETE_PURCHASEORDER_REQUEST });

  try {
    const headerData = {
      api_token: localStorage.getItem("apiToken"),
      customerNo: localStorage.getItem("customerNo"),
      userId: localStorage.getItem("userId"),
      poReferenceNo: id,
    };

    const { data } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/delete`,
      headerData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    dispatch({ type: DELETE_PURCHASEORDER_SUCCESS, payload: data });
    window.location.reload();
  } catch (error) {
    cogoToast.error(error.message, { position: "top-right" });
    dispatch({ type: DELETE_PURCHASEORDER_FAIL, payload: error.message });
  }
};

export const updatePurchaseOrder =
  (updatePOData, handleClose) => async (dispatch) => {
    dispatch({ type: UPDATE_PURCHASEORDER_REQUEST });

    try {
      const { data } = await Axios.post(
        `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/update`,
        updatePOData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("apiToken"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      dispatch({ type: UPDATE_PURCHASEORDER_SUCCESS, payload: data });

      if (data.status === 0) {
        cogoToast.error(data.message, { position: "top-right" });
      } else {
        if (handleClose) {
          cogoToast
            .success(data.message, { position: "top-right" })
            .then(() => {
              handleClose(true);
            });
        } else {
          cogoToast
            .success(data.message, { position: "top-right" })
            .then(() => {
              window.location.href = "/purchaseorder";
            });
        }
      }
    } catch (error) {
      if (error.response.data.status === 0) {
        cogoToast.error(error.response.data.message, { position: "top-right" });
      }
      dispatch({ type: UPDATE_PURCHASEORDER_FAIL, payload: error.message });
    }
  };

export const createPurchaseOrder = (createPOData) => async (dispatch) => {
  dispatch({ type: CREATE_PURCHASEORDER_REQUEST });

  try {
    const { data, message } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/create`,
      createPOData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    if (data.status === 0) {
      cogoToast.error(data.message, { position: "top-right" });
    } else {
      cogoToast.success(data.message, { position: "top-right" }).then(() => {
        window.location.href = "/purchaseorder";
      });
    }

    dispatch({ type: CREATE_PURCHASEORDER_SUCCESS, payload: data });
  } catch (error) {
    if (error.response.data.status === 0) {
      cogoToast.error(error.response.data.message, { position: "top-right" });
    }
    dispatch({ type: CREATE_PURCHASEORDER_FAIL, payload: error.message });
  }
};

export const getPurchaseOrder = (id) => async (dispatch) => {
  dispatch({ type: GET_PURCHASEORDER_REQUEST });

  try {
    const headerData = (id) => {
      if (id) {
        return {
          api_token: localStorage.getItem("apiToken"),
          customerNo: localStorage.getItem("customerNo"),
          userId: localStorage.getItem("userId"),
          poId: id,
        };
      } else {
        return {
          api_token: localStorage.getItem("apiToken"),
          customerNo: localStorage.getItem("customerNo"),
          userId: localStorage.getItem("userId"),
        };
      }
    };

    const { data } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPurchaseOrders`,
      headerData(id),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data });
  } catch (error) {
    if (error?.response?.data?.status === 400) {
      cogoToast.error(error.response.data.message, { position: "top-right" });
    }
    dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message });
  }
};

export const getPurchaseOrderPagination = (page,filterData) => async (dispatch) => {
  dispatch({ type: GET_PURCHASEORDER_REQUEST });
  const { userId, customerNo, userToken } = LOCAL_STORAGE;
  try {
    const headerData = () => {
      if(filterData){
        return {
          api_token: localStorage.getItem('apiToken'),
          customerNo: localStorage.getItem('customerNo'),
          userId: localStorage.getItem('userId'),
          vendorCode:filterData?.vendorCode ? filterData.vendorCode : '',
          vehicleId:filterData?.vehicleId ? filterData.vehicleId: '',
          branchId:filterData?.branch ? filterData.branch: '',
          searchString: filterData.searchString ? filterData.searchString : '',
          lrNumbers:filterData.lrNumbers ? filterData.lrNumbers : ''
        }
      } else {
      return {
        api_token: userToken,
        customerNo,
        userId,
      };}
    }

    const { data } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPOPagination?page=${page}`,
      headerData(),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );

    dispatch({ type: GET_PURCHASEORDER_SUCCESS, payload: data });
    dispatch({ type: GET_PURCHASEORDER_PAGINATION, payload: data.pagination });
  } catch (error) {
    if (error?.response?.data?.status === 400) {
      cogoToast.error(error.response.data.message, { position: "top-right" });
    }
    dispatch({ type: GET_PURCHASEORDER_FAIL, payload: error.message });
  }
};

export const getVendorPurchaseOrder =
  (vendorData, vendorCode, pageNo, searchString, edit,isUsed) => async (dispatch) => {
    let stringPass = searchString?.length > 0 ? searchString : "";

    dispatch({ type: GET_VENDORPURCHASEORDER_REQUEST });

    try {
      const headerData = (vendorCode, edit) => {
        if (vendorData && edit && isUsed != true ) {
          return {
            api_token: localStorage.getItem("apiToken"),
            customerNo: localStorage.getItem("customerNo"),
            userId: localStorage.getItem("userId"),
            vendorCode: vendorData.vendorCode,
            billId: vendorData.billId,
            /* isUsed: "0", */
            searchString: stringPass,
          };
        } else if(isUsed == true) {
          return {
            api_token: localStorage.getItem("apiToken"),
            customerNo: localStorage.getItem("customerNo"),
            userId: localStorage.getItem("userId"),
            vendorCode: vendorData.vendorCode,
            billId: vendorData.billId,
            isUsed: "0", 
            searchString: stringPass,
          }}else {
            return {
              api_token: localStorage.getItem("apiToken"),
              customerNo: localStorage.getItem("customerNo"),
              userId: localStorage.getItem("userId"),
              vendorCode: vendorCode,
              isUsed: "0",
              searchString: stringPass,
            };
        }
      };

      const { data } = await Axios.post(
        `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPOPagination?page=${pageNo}`,
        headerData(vendorCode, edit),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("apiToken"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      dispatch({ type: GET_VENDORPURCHASEORDER_SUCCESS, payload: data });
    } catch (error) {
      if (error.response.data.status === 400) {
        cogoToast.error(error.response.data.message, { position: "top-right" });
      }
      dispatch({ type: GET_VENDORPURCHASEORDER_FAIL, payload: error.message });
    }
  };

export const getMappedVendorPurchaseOrder = async(vendorData, vendorCode, pageNo, searchString, edit, isMapped,billData)  => {

  let stringPass = searchString?.length > 0 ? searchString : "";

  try {
    const headerData = (vendorCode) => {
      if (isMapped) {
        return {
          api_token: localStorage.getItem("apiToken"),
          customerNo: localStorage.getItem("customerNo"),
          userId: localStorage.getItem("userId"),
          vendorCode: vendorCode,
          searchString: stringPass,
          billId: billData,
        }
      }
    };

    const { data } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}/purchase/purchaseorder/getPoBillMapping?page=${pageNo}`,
      headerData(vendorCode),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    return data
  } catch (error) {
    if (error.response.data.status === 400) {
      cogoToast.error(error.response.data.message, { position: "top-right" });
    }
  }
};

export const getVendorPurchaseOrderPo =
  (vendorData, edit) => async (dispatch) => {
    dispatch({ type: GET_VENDORPURCHASEORDER_REQUEST });

    try {
      const headerData = (vendorCode, edit) => {
        if (vendorData && edit) {
          return {
            api_token: localStorage.getItem("apiToken"),
            customerNo: localStorage.getItem("customerNo"),
            userId: localStorage.getItem("userId"),
            vendorCode: vendorData.vendorCode,
            billId: vendorData.billId,
            isUsed: "0",
          };
        } else {
          return {
            api_token: localStorage.getItem("apiToken"),
            customerNo: localStorage.getItem("customerNo"),
            userId: localStorage.getItem("userId"),
            vendorCode: vendorCode,
            isUsed: "0",
          };
        }
      };

      const { data } = await Axios.post(
        `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/getPurchaseOrders`,
        headerData(vendorData, edit),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("apiToken"),
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      dispatch({ type: GET_VENDORPURCHASEORDER_SUCCESS, payload: data });
    } catch (error) {
      if (error.response.data.status === 400) {
        cogoToast.error(error.response.data.message, { position: "top-right" });
      }
      dispatch({ type: GET_VENDORPURCHASEORDER_FAIL, payload: error.message });
    }
  };

  export const selectSoData = (data) => async (dispatch) => {
    try {
        dispatch({ type: ADD_SELECTED_INVOICE, payload: data });
    } catch (error) {
        dispatch({ type: REMOVE_SELECTED_INVOICE, payload: error.message })
    }
}

export const clearSelectPoData = () => async (dispatch) => {
  console.log('clear data called')
  try {
      dispatch({ type: CLEAR_SELECTED_PO, payload: [] });
  } catch (error) {
      dispatch({ type: REMOVE_SELECTED_PO, payload: error.message })
  }
}


export const getGeneratedPdf = (poRefNo) => async (dispatch) => {
  dispatch({ type: GENERATE_PDF_REQUEST });
  const { userId, customerNo, userToken, customerCompanyName, customerName, customerLogo } = LOCAL_STORAGE;

  try {
    const headerData = {
      api_token: userToken,
      customerNo: customerNo,
      userId: userId,
      poReferenceNo: poRefNo,
      loginDts: {
        customerCompanyName: customerCompanyName,
        customerName: customerName,
        customerLogo: customerLogo
      }
    };

    const { data } = await Axios.post(
      `${APP_CONSTANT.BASE_URL}purchase/purchaseorder/generatePdf`,
      headerData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("apiToken"),
          "Access-Control-Allow-Origin": "*",
        },
      }
    );
    dispatch({ type: GENERATE_PDF_SUCCESS, payload: data });
    window.open(data.data);
  } catch (error) {
    if (error.response.data.status === 400) {
      cogoToast.error(error.response.data.message, { position: "top-right" });
    }
    dispatch({ type: GENERATE_PDF_FAIL, payload: error.message });
  }
};
